import Cookies from 'js-cookie';
import { COOKIE_CONSTANT, FALLBACK_LOCALE, LOCALE_MAPPING, PAGE_NAME } from '../constant/constant';
export const encodeValue = ( value: any ) => {
    return encodeURIComponent(btoa(JSON.stringify(value)));
}

export const decodeValue = ( value: any ) => {
    return atob(decodeURIComponent(value));
}

export const setCookie = ( key: string, value: string, option: {} ) => {
    Cookies.set(key, value, option);
}
    

export const deleteCookie = ( key: string ) => {
    Cookies.remove(key,{ path: '/' });
}

export const getCookie = ( key: string ): string => {
    return Cookies.get(key) || '';
}

export const getCurrentPageCookie = () => {
    const currentPageCookie = getCookie(COOKIE_CONSTANT.CURRENT_PAGE_COOKIE_KEY) || ':';
    const [currentScreenId, screenTypeFromCookie] = currentPageCookie.split(':');

    return {
        currentScreenId: parseInt(currentScreenId) || 0,
        currentScreenType: screenTypeFromCookie
    }
}

export const setCurrentPageCookie = ( value: string, screenId: number = 0) => {
    const { currentScreenId } = getCurrentPageCookie();

    if(screenId < currentScreenId){
        screenId = currentScreenId;
    }

    setCookie(COOKIE_CONSTANT.CURRENT_PAGE_COOKIE_KEY, `${screenId}:${value}`, {})
}

export const redirectToAuthcallback = (authFrontLock:any, errorCode: string, email?: string) => {
    const uiLocale = authFrontLock.getUILocales();
    const finalLocale = uiLocale && uiLocale.length > 0 ? uiLocale[0] : FALLBACK_LOCALE;
    const state = {
        redirectURL: `${process.env.REACT_APP_SITE_BASE_URL || 'https://stg-www.pens.com'}/${LOCALE_MAPPING[finalLocale]}`,
        clientId: process.env.REACT_APP_AUTHFRONT_SDK_CLIENT_ID
    };
    let additionalParams = {
        screenType: PAGE_NAME.SIGN_IN,
    };

    const callbackUrl = `${process.env.REACT_APP_SITE_BASE_URL || 'https://stg-www.pens.com'}/auth-callback?state=${encodeValue(state)}&additional_params=${encodeValue(additionalParams)}&ui_locales=${finalLocale}&error=${errorCode}&login_hint=${encodeURIComponent(email || '')}`;
    window.location.replace(callbackUrl);
}